<template>
  <div
    class="article-content-container d-flex align-center flex-column"
    ref="articleStart"
  >
    <ArticleTitleRow
      :title="article.title"
      :description="article.description"
    />
    <v-img :src="article.imageUrl" cover class="article-image" />
    <div class="article-page-content">
      <template v-for="(item, index) in processedContent">
        <div
          v-if="item.type === 'html'"
          :key="`html-${index}`"
          v-html="item.content"
        ></div>
        <CreateYourWillBanner
          v-else-if="item.type === 'banner'"
          :key="`banner-${index}`"
          :isArticle="true"
          :bannerText="item.bannerText"
          @createYourWill="signupClicked"
        />
      </template>
      <SocialMedia />
    </div>
  </div>
</template>

<script>
  import ArticleTitleRow from '../../common/ArticleTitleRow.vue';
  import SocialMedia from '../../common/SocialMedia.vue';
  import CreateYourWillBanner from '../CreateYourWillBanner.vue';

  export default {
    name: 'ArticleContent',
    components: {
      ArticleTitleRow,
      SocialMedia,
      CreateYourWillBanner,
    },
    methods: {
      signupClicked() {
        this.$router.push('/register');
      },
    },
    computed: {
      processedContent() {
        return this.article.content.map(item => {
          const bannerMatch = item.match(/<CreateYourWillBanner/);
          if (bannerMatch) {
            const bannerText = item.match(/bannerText="([^"]*)"/)?.[1];
            return {
              type: 'banner',
              bannerText: bannerText,
            };
          }
          return { type: 'html', content: item };
        });
      },
    },
    props: {
      article: {
        required: true,
        type: Object,
        default: () => ({}),
      },
    },
  };
</script>

<style lang="scss">
  .article-content-container {
    .article-image {
      width: clamp(33%, 95dvw, 766px);
      height: clamp(33%, 95dvw, 432px);
    }
    .breadcrumb-container {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .article-page-content {
      padding-top: 40px;
      max-width: 768px;
    }
  }
  @media screen and (min-width: 801px) and (max-width: 1000px) {
    .article-content-container {
      padding-top: 60px !important;
    }
  }
</style>
